<p-tabs [value]="selectedTab" (valueChange)="selectTab(+($event ?? 0))" [class]="'tabs-' + type">
  <p-tablist>
    @for (tab of tabHeaders; track $index; let i = $index) {
      @if (!tab.hidden) {
      <p-tab [value]="i" [disabled]="!!tab.disabled">
        @if (type === 'type3' && tab.icon) {
          <div class="tab-content-type3">
            @if (tab.icon.endsWith('.png') || tab.icon.startsWith('data:image/') || tab.icon.endsWith('.svg')) {
              <img [src]="tab.icon" [alt]="tab.label || (tab.labelKey | transloco)" class="tab-icon" />
            } @else {
              <lucide-icon [name]="tab.icon" [size]="iconSize"></lucide-icon>
            }
            @if (!iconOnly) {
              <span>{{ tab.label || (tab.labelKey | transloco) }}</span>
            }
          </div>
        } @else if (type === 'type2' && tab.icon) {
          <div class="tab-content-type2">
            @if (tab.icon.endsWith('.png') || tab.icon.startsWith('data:image/')) {
              <img [src]="tab.icon" [alt]="tab.label || (tab.labelKey | transloco)" class="tab-icon" />
            } @else if (tab.icon.endsWith('.svg')) {
              <span class="tab-icon-svg" [style.maskImage]="'url(' + tab.icon + ')'" [style.webkitMaskImage]="'url(' + tab.icon + ')'"></span>
            } @else {
              <lucide-icon [name]="tab.icon" [size]="iconSize"></lucide-icon>
            }
            @if (!iconOnly) {
              <span>{{ tab.label || (tab.labelKey | transloco) }}</span>
            }
          </div>
        } @else if (type === 'pill' && tab.icon) {
          <div
            class="tab-content-type2"
            [pTooltip]="iconOnly ? (tab.label || (tab.labelKey ? (tab.labelKey | transloco) : '')) : ''"
            tooltipPosition="top"
            tooltipStyleClass="tooltip-sidebar"
            [showDelay]="300">
            @if (tab.icon.endsWith('.png') || tab.icon.startsWith('data:image/') || tab.icon.endsWith('.svg')) {
              <img [src]="tab.icon" [alt]="tab.label || (tab.labelKey | transloco)" class="tab-icon" />
            } @else {
              <lucide-icon [name]="tab.icon" [size]="20"></lucide-icon>
            }
            @if (!iconOnly) {
              <span>{{ tab.label || (tab.labelKey | transloco) }}</span>
            }
          </div>
        } @else if (type === 'type1' && tab.icon && iconOnly) {
          <div class="tab-content-type1">
            @if (tab.icon.endsWith('.png') || tab.icon.startsWith('data:image/') || tab.icon.endsWith('.svg')) {
              <img [src]="tab.icon" [alt]="tab.label || (tab.labelKey | transloco)" class="tab-icon" />
            } @else {
              <lucide-icon [name]="tab.icon" [size]="iconSize"></lucide-icon>
            }
          </div>
        } @else if (type === 'type1' && tab.icon) {
          <div class="tab-content-type1">
            <span class="tab-icon-wrap">
              @if (tab.icon.endsWith('.png') || tab.icon.startsWith('data:image/') || tab.icon.endsWith('.svg')) {
                <img [src]="tab.icon" [alt]="tab.label || (tab.labelKey | transloco)" class="tab-icon" />
              } @else {
                <lucide-icon [name]="tab.icon" [size]="iconSize"></lucide-icon>
              }
              @if (tab.badge) {
                <span class="tab-badge">{{ tab.badge }}</span>
              }
            </span>
            <span>{{ tab.label || (tab.labelKey | transloco) }}</span>
          </div>
        } @else {
          {{ tab.label || (tab.labelKey | transloco) }}
        }
      </p-tab>
      }
    }
  </p-tablist>
</p-tabs>